import { createStructuredSelector } from 'reselect'

import {
  SEARCH_DOCUMENT_TYPE,
  SEARCH_DOCUMENT_TYPE_SUCCESS,
  SEARCH_DOCUMENT_TYPE_ERROR,
  SEARCH_EQUIPMENT_DELIVERY_ORDER,
  SEARCH_EQUIPMENT_DELIVERY_ORDER_SUCCESS,
  SEARCH_EQUIPMENT_DELIVERY_ORDER_ERROR,
  SEARCH_DELIVERY_ORDER_LINE_LOT,
  SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  SEARCH_DELIVERY_ORDER_LINE,
  SEARCH_DELIVERY_ORDER_LINE_SUCCESS,
  SEARCH_DELIVERY_ORDER_LINE_ERROR,
  SEARCH_STATUS_REVIEW,
  SEARCH_STATUS_REVIEW_SUCCESS,
  SEARCH_STATUS_REVIEW_ERROR,
  SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL,
  SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS,
  SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR,
  SEARCH_CATEGORY_MAINTENANCE_DELAY,
  SEARCH_CATEGORY_MAINTENANCE_DELAY_SUCCESS,
  SEARCH_CATEGORY_MAINTENANCE_DELAY_ERROR,
  SEARCH_HOSPITAL_SECTION,
  SEARCH_HOSPITAL_SECTION_SUCCESS,
  SEARCH_HOSPITAL_SECTION_ERROR,
  SEARCH_HOSPITAL_SERVICE,
  SEARCH_HOSPITAL_SERVICE_SUCCESS,
  SEARCH_HOSPITAL_SERVICE_ERROR,
  SEARCH_REQUEST_TYPE,
  SEARCH_REQUEST_TYPE_SUCCESS,
  SEARCH_REQUEST_TYPE_ERROR,
  SEARCH_REQUEST_TYPE_DETAIL,
  SEARCH_REQUEST_TYPE_DETAIL_SUCCESS,
  SEARCH_REQUEST_TYPE_DETAIL_ERROR,
  SEARCH_PRIORITY,
  SEARCH_PRIORITY_SUCCESS,
  SEARCH_PRIORITY_ERROR,
  SEARCH_REQUEST_STATUS,
  SEARCH_REQUEST_STATUS_SUCCESS,
  SEARCH_REQUEST_STATUS_ERROR,
  SEARCH_REQUEST_PROCESS_TYPE,
  SEARCH_REQUEST_PROCESS_TYPE_SUCCESS,
  SEARCH_REQUEST_PROCESS_TYPE_ERROR,
  SEARCH_ACTION_REQUEST,
  SEARCH_ACTION_REQUEST_SUCCESS,
  SEARCH_ACTION_REQUEST_ERROR,
  SEARCH_HEALTH_REGISTRY_AGENCY,
  SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS,
  SEARCH_HEALTH_REGISTRY_AGENCY_ERROR,
  SEARCH_BMP_AGENCY,
  SEARCH_BMP_AGENCY_SUCCESS,
  SEARCH_BMP_AGENCY_ERROR,
  SEARCH_RISK_TYPE,
  SEARCH_RISK_TYPE_SUCCESS,
  SEARCH_RISK_TYPE_ERROR,
  SEARCH_GHTF,
  SEARCH_GHTF_SUCCESS,
  SEARCH_GHTF_ERROR,
  SEARCH_DIAGNOSTIC_CLASS,
  SEARCH_DIAGNOSTIC_CLASS_SUCCESS,
  SEARCH_DIAGNOSTIC_CLASS_ERROR,
  SEARCH_ISO,
  SEARCH_ISO_SUCCESS,
  SEARCH_ISO_ERROR,
  SEARCH_GT_CERTIFICATE,
  SEARCH_GT_CERTIFICATE_SUCCESS,
  SEARCH_GT_CERTIFICATE_ERROR,
  SEARCH_SERVICE_TYPE,
  SEARCH_SERVICE_TYPE_SUCCESS,
  SEARCH_SERVICE_TYPE_ERROR,
  SEARCH_BIOEQUIVALENCE,
  SEARCH_BIOEQUIVALENCE_SUCCESS,
  SEARCH_BIOEQUIVALENCE_ERROR,
  SEARCH_VEHICLE_TYPE,
  SEARCH_VEHICLE_TYPE_SUCCESS,
  SEARCH_VEHICLE_TYPE_ERROR,
  SEARCH_FREQUENCY_MTO,
  SEARCH_FREQUENCY_MTO_SUCCESS,
  SEARCH_FREQUENCY_MTO_ERROR,
  SEARCH_AMBULANCE_PLATE,
  SEARCH_AMBULANCE_PLATE_SUCCESS,
  SEARCH_AMBULANCE_PLATE_ERROR,
  SEARCH_AMBULANCE_CHASIS,
  SEARCH_AMBULANCE_CHASIS_SUCCESS,
  SEARCH_AMBULANCE_CHASIS_ERROR,
  SEARCH_AMBULANCE_CODE_IGSS,
  SEARCH_AMBULANCE_CODE_IGSS_SUCCESS,
  SEARCH_AMBULANCE_CODE_IGSS_ERROR
} from '../actions';

export const SEARCH_NAME = 'search';
const NAME = SEARCH_NAME;


export const SearchDocumentType = (data) => ({
  type: SEARCH_DOCUMENT_TYPE,
  payload: data
});

export const SearchDocumentTypeSuccess = (data) => ({
  type: SEARCH_DOCUMENT_TYPE_SUCCESS,
  payload: data
});

export const SearchDocumentTypeError = (error) => ({
  type: SEARCH_DOCUMENT_TYPE_ERROR,
  payload: error
});

export const SearchEquipmentDeliveryOrder = (data) => ({
  type: SEARCH_EQUIPMENT_DELIVERY_ORDER,
  payload: data
});

export const SearchEquipmentDeliveryOrderSuccess = (data) => ({
  type: SEARCH_EQUIPMENT_DELIVERY_ORDER_SUCCESS,
  payload: data
});

export const SearchEquipmentDeliveryOrderError = (error) => ({
  type: SEARCH_EQUIPMENT_DELIVERY_ORDER_ERROR,
  payload: {filters: filters}
});

export const SearchDeliveryOrderLineLot = (data) => ({
  type: SEARCH_DELIVERY_ORDER_LINE_LOT,
  payload: data
});

export const SearchDeliveryOrderLineLotSuccess = (data) => ({
  type: SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  payload: data
});

export const SearchDeliveryOrderLineLotError = (error) => ({
  type: SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  payload: error
});

export const SearchDeliveryOrderLine = (data) => ({
  type: SEARCH_DELIVERY_ORDER_LINE,
  payload: data
});

export const SearchDeliveryOrderLineSuccess = (data) => ({
  type: SEARCH_DELIVERY_ORDER_LINE_SUCCESS,
  payload: data
});

export const SearchDeliveryOrderLineError = (error) => ({
  type: SEARCH_DELIVERY_ORDER_LINE_ERROR,
  payload: error
});

export const SearchStatusReview = (data) => ({
  type: SEARCH_STATUS_REVIEW,
  payload: data
});

export const SearchStatusReviewSuccess = (data) => ({
  type: SEARCH_STATUS_REVIEW_SUCCESS,
  payload: data
});

export const SearchStatusReviewError = (error) => ({
  type: SEARCH_STATUS_REVIEW_ERROR,
  payload: error
});

export const SearchEquipmentScheduleMaintenanceDetail = (filters) => ({
  type: SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL,
  payload: {filters: filters}
}); 

export const SearchEquipmentScheduleMaintenanceDetailSuccess = (data) => ({
  type: SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS,
  payload: data
});

export const SearchEquipmentScheduleMaintenanceDetailError = (error) => ({
  type: SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR,
  payload: error
});

export const SearchCategoryMaintenanceDelay = () => ({
  type: SEARCH_CATEGORY_MAINTENANCE_DELAY
});

export const SearchCategoryMaintenanceDelaySuccess = (data) => ({
  type: SEARCH_CATEGORY_MAINTENANCE_DELAY_SUCCESS,
  payload: data
});

export const SearchCategoryMaintenanceDelayError = (error) => ({
  type: SEARCH_CATEGORY_MAINTENANCE_DELAY_ERROR,
  payload: error
});

export const SearchHospitalService = () => ({
  type: SEARCH_HOSPITAL_SERVICE
});

export const SearchHospitalServiceSuccess = (data) => ({
  type: SEARCH_HOSPITAL_SERVICE_SUCCESS,
  payload: data
});

export const SearchHospitalServiceError = (error) => ({
  type: SEARCH_HOSPITAL_SERVICE_ERROR,
  payload: error
});

export const SearchHospitalSection = (filters) => ({
  type: SEARCH_HOSPITAL_SECTION,
  payload: {filters: filters}
});

export const SearchHospitalSectionSuccess = (data) => ({
  type: SEARCH_HOSPITAL_SECTION_SUCCESS,
  payload: data
});

export const SearchHospitalSectionError = (error) => ({
  type: SEARCH_HOSPITAL_SECTION_ERROR,
  payload: error
});

export const SearchRequestType = () => ({
  type: SEARCH_REQUEST_TYPE
});

export const SearchRequestTypeSuccess = (data) => ({
  type: SEARCH_REQUEST_TYPE_SUCCESS,
  payload: data
});

export const SearchRequestTypeError = (error) => ({
  type: SEARCH_REQUEST_TYPE_ERROR,
  payload: error
});

export const SearchRequestTypeDetail = () => ({
  type: SEARCH_REQUEST_TYPE_DETAIL
});

export const SearchRequestTypeDetailSuccess = (data) => ({
  type: SEARCH_REQUEST_TYPE_DETAIL_SUCCESS,
  payload: data
});

export const SearchRequestTypeDetailError = (error) => ({
  type: SEARCH_REQUEST_TYPE_DETAIL_ERROR,
  payload: error
});

export const SearchPriority = () => ({
  type: SEARCH_PRIORITY
});

export const SearchPrioritySuccess = (data) => ({
  type: SEARCH_PRIORITY_SUCCESS,
  payload: data
});

export const SearchPriorityError = (error) => ({
  type: SEARCH_PRIORITY_ERROR,
  payload: error
});

export const SearchRequestStatus = (data) => ({
  type: SEARCH_REQUEST_STATUS,
  payload: data
});

export const SearchRequestStatusSuccess = (data) => ({
  type: SEARCH_REQUEST_STATUS_SUCCESS,
  payload: data
});

export const SearchRequestStatusError = (error) => ({
  type: SEARCH_REQUEST_STATUS_ERROR,
  payload: error
});

export const SearchRequestProcessType = (data) => ({
  type: SEARCH_REQUEST_PROCESS_TYPE,
  payload: data
});

export const SearchRequestProcessTypeSuccess = (data) => ({
  type: SEARCH_REQUEST_PROCESS_TYPE_SUCCESS,
  payload: data
});

export const SearchRequestProcessTypeError = (error) => ({
  type: SEARCH_REQUEST_PROCESS_TYPE_ERROR,
  payload: error
});

export const SearchActionRequest = (data) => ({
  type: SEARCH_ACTION_REQUEST,
  payload: data
});

export const SearchActionRequestSuccess = (data) => ({
  type: SEARCH_ACTION_REQUEST_SUCCESS,
  payload: data
});

export const SearchActionRequestError = (error) => ({
  type: SEARCH_ACTION_REQUEST_ERROR,
  payload: error
});

export const SearchHealthRegistryAgency = (data) => ({
  type: SEARCH_HEALTH_REGISTRY_AGENCY,
  payload: data
});

export const SearchHealthRegistryAgencySuccess = (data) => ({
  type: SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS,
  payload: data
});

export const SearchHealthRegistryAgencyError = (error) => ({
  type: SEARCH_HEALTH_REGISTRY_AGENCY_ERROR,
  payload: error
});

export const SearchBmpAgency = (data) => ({
  type: SEARCH_BMP_AGENCY,
  payload: data
});

export const SearchBmpAgencySuccess = (data) => ({
  type: SEARCH_BMP_AGENCY_SUCCESS,
  payload: data
});

export const SearchBmpAgencyError = (error) => ({
  type: SEARCH_BMP_AGENCY_ERROR,
  payload: error
});

export const SearchRiskType = (data) => ({
  type: SEARCH_RISK_TYPE,
  payload: data
});

export const SearchRiskTypeSuccess = (data) => ({
  type: SEARCH_RISK_TYPE_SUCCESS,
  payload: data
});

export const SearchRiskTypeError = (error) => ({
  type: SEARCH_RISK_TYPE_ERROR,
  payload: error
});

export const SearchGhtf = (data) => ({
  type: SEARCH_GHTF,
  payload: data
});

export const SearchGhtfSuccess = (data) => ({
  type: SEARCH_GHTF_SUCCESS,
  payload: data
});

export const SearchGhtfError = (error) => ({
  type: SEARCH_GHTF_ERROR,
  payload: error
});

export const SearchDiagnosticClass = (data) => ({
  type: SEARCH_DIAGNOSTIC_CLASS,
  payload: data
});

export const SearchDiagnosticClassSuccess = (data) => ({
  type: SEARCH_DIAGNOSTIC_CLASS_SUCCESS,
  payload: data
});

export const SearchDiagnosticClassError = (error) => ({
  type: SEARCH_DIAGNOSTIC_CLASS_ERROR,
  payload: error
});

export const SearchIso = (data) => ({
  type: SEARCH_ISO,
  payload: data
});

export const SearchIsoSuccess = (data) => ({
  type: SEARCH_ISO_SUCCESS,
  payload: data
});

export const SearchIsoError = (error) => ({
  type: SEARCH_ISO_ERROR,
  payload: error
});

export const SearchGtCertificate = (data) => ({
  type: SEARCH_GT_CERTIFICATE,
  payload: data
});

export const SearchGtCertificateSuccess = (data) => ({
  type: SEARCH_GT_CERTIFICATE_SUCCESS,
  payload: data
});

export const SearchGtCertificateError = (error) => ({
  type: SEARCH_GT_CERTIFICATE_ERROR,
  payload: error
});

export const SearchServiceType = (data) => ({
  type: SEARCH_SERVICE_TYPE,
  payload: data
});

export const SearchServiceTypeSuccess = (data) => ({
  type: SEARCH_SERVICE_TYPE_SUCCESS,
  payload: data
});

export const SearchServiceTypeError = (error) => ({
  type: SEARCH_SERVICE_TYPE_ERROR,
  payload: error
});

export const SearchBioequivalence = (data) => ({
  type: SEARCH_BIOEQUIVALENCE,
  payload: data
});

export const SearchBioequivalenceSuccess = (data) => ({
  type: SEARCH_BIOEQUIVALENCE_SUCCESS,
  payload: data
});

export const SearchBioequivalenceError = (error) => ({
  type: SEARCH_BIOEQUIVALENCE_ERROR,
  payload: error
});

export const SearchVehicleType = (data) => ({
  type: SEARCH_VEHICLE_TYPE,
  payload: data
});

export const SearchVehicleTypeSuccess = (data) => ({
  type: SEARCH_VEHICLE_TYPE_SUCCESS,
  payload: data
});

export const SearchVehicleTypeError = (error) => ({
  type: SEARCH_VEHICLE_TYPE_ERROR,
  payload: error
});

export const SearchFrequencyMto = () => ({
  type: SEARCH_FREQUENCY_MTO
});

export const SearchFrequencyMtoSuccess = (data) => ({
  type: SEARCH_FREQUENCY_MTO_SUCCESS,
  payload: data
});

export const SearchFrequencyMtoError = (error) => ({
  type: SEARCH_FREQUENCY_MTO_ERROR,
  payload: error
});

export const SearchAmbulancePlate = () => ({
  type: SEARCH_AMBULANCE_PLATE
});

export const SearchAmbulancePlateSuccess = (data) => ({
  type: SEARCH_AMBULANCE_PLATE_SUCCESS,
  payload: data
});

export const SearchAmbulancePlateError = (error) => ({
  type: SEARCH_AMBULANCE_PLATE_ERROR,
  payload: error
});

export const SearchAmbulanceChasis = () => ({
  type: SEARCH_AMBULANCE_CHASIS
});

export const SearchAmbulanceChasisSuccess = (data) => ({
  type: SEARCH_AMBULANCE_CHASIS_SUCCESS,
  payload: data
});

export const SearchAmbulanceChasisError = (error) => ({
  type: SEARCH_AMBULANCE_CHASIS_ERROR,
  payload: error
});

export const SearchAmbulanceCodeIgss = () => ({
  type: SEARCH_AMBULANCE_CODE_IGSS
});

export const SearchAmbulanceCodeIgssSuccess = (data) => ({
  type: SEARCH_AMBULANCE_CODE_IGSS_SUCCESS,
  payload: data
});

export const SearchAmbulanceCodeIgssError = (error) => ({
  type: SEARCH_AMBULANCE_CODE_IGSS_ERROR,
  payload: error
});

const search = (state) => state[NAME];

export const SearchSelector = createStructuredSelector({
  search
})
